import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "María García",
    role: "Cliente frecuente",
    avatar: "MG",
    rating: 5,
    text: "¡Increíble! La app es súper fácil de usar y siempre llega caliente. Mis noches de pizza nunca fueron mejores.",
    color: "bg-pink-500",
  },
  {
    name: "Carlos Rodríguez",
    role: "Dueño de Tacos El Rey",
    avatar: "CR",
    rating: 5,
    text: "Desde que me uní a Apedir, mis ventas aumentaron un 60%. El panel de control es muy útil.",
    color: "bg-blue-500",
  },
  {
    name: "Ana Martínez",
    role: "Cliente verificada",
    avatar: "AM",
    rating: 5,
    text: "El seguimiento en tiempo real es genial. Siempre sé exactamente cuándo llegará mi comida. ¡5 estrellas!",
    color: "bg-purple-500",
  },
  {
    name: "Roberto Sánchez",
    role: "Chef de Sushi House",
    avatar: "RS",
    rating: 5,
    text: "Las comisiones son justas y el soporte es excelente. Recomiendo Apedir a todos los restaurantes.",
    color: "bg-green-500",
  },
  {
    name: "Laura Jiménez",
    role: "Foodie entusiasta",
    avatar: "LJ",
    rating: 5,
    text: "Descubrí tantos restaurantes nuevos gracias a Apedir. Las ofertas exclusivas son increíbles.",
    color: "bg-orange-500",
  },
  {
    name: "Diego Torres",
    role: "Dueño de Burger Lab",
    avatar: "DT",
    rating: 5,
    text: "La integración fue súper rápida. En menos de una semana ya estaba recibiendo pedidos.",
    color: "bg-teal-500",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonios" className="py-24 bg-muted/30 overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="uppercase text-xs tracking-[0.2em] font-bold text-primary">
            Testimonios
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-foreground mt-4">
            Lo Que Dicen Nuestros Usuarios
          </h2>
          <p className="text-base md:text-lg text-muted-foreground mt-4 max-w-2xl mx-auto">
            Miles de clientes y restaurantes confían en Apedir. 
            Descubre por qué somos su primera opción.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="testimonial-card neumorphic rounded-2xl p-6 relative"
              data-testid={`testimonial-card-${index + 1}`}
            >
              {/* Quote Icon */}
              <Quote className="absolute top-4 right-4 w-8 h-8 text-primary/20" />

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-yellow-400 text-yellow-400"
                  />
                ))}
              </div>

              {/* Text */}
              <p className="text-foreground mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 ${testimonial.color} rounded-full flex items-center justify-center text-white font-bold text-sm`}>
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-bold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Trust Badges */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="mt-16 text-center"
        >
          <div className="flex flex-wrap justify-center items-center gap-8 text-muted-foreground">
            <div className="flex items-center gap-2" data-testid="trust-badge-rating">
              <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              <span className="font-bold text-foreground">4.9</span>
              <span>Calificación promedio</span>
            </div>
            <div className="w-px h-6 bg-border hidden md:block" />
            <div data-testid="trust-badge-downloads">
              <span className="font-bold text-foreground">10K+</span>
              <span className="ml-1">Descargas</span>
            </div>
            <div className="w-px h-6 bg-border hidden md:block" />
            <div data-testid="trust-badge-restaurants">
              <span className="font-bold text-foreground">100+</span>
              <span className="ml-1">Restaurantes asociados</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
